import { render, staticRenderFns } from "./caseDetails.vue?vue&type=template&id=543d99fe&scoped=true&"
import script from "./caseDetails.vue?vue&type=script&lang=js&"
export * from "./caseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543d99fe",
  null
  
)

export default component.exports